export default __webpack_public_path__ + "img/e0db662938015828916292dd789addeb.png";